import { render, staticRenderFns } from "./PersonalFormPanel.vue?vue&type=template&id=055da2ff&scoped=true"
import script from "./PersonalFormPanel.vue?vue&type=script&lang=js"
export * from "./PersonalFormPanel.vue?vue&type=script&lang=js"
import style0 from "./PersonalFormPanel.vue?vue&type=style&index=0&id=055da2ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055da2ff",
  null
  
)

export default component.exports